import React from 'react';
import dayjs from 'dayjs';
import store from '../../shared/store';
import Request from '../../shared/request';
import i18n from '../../shared/i18n';

class VasCards extends React.Component {
  state = {
    deviceUsed: 0,
    clientBtn: i18n.t('dash-vas-device'),
    clientLink: '/dashboard/vas',
    bandwidthBtn: i18n.t('dash-vas-bw'),
    gameBandwidthBtn: i18n.t('dash-vas-gbw'),
    bandwidthLink: '/dashboard/vas?planId=bandwidth_100',
    gameBandwidthLink: '/dashboard/vas?planId=game_bandwidth_50',
  };

  goBind = () => {
    this.props.history.push('/dashboard/bind');
  };

  async componentDidMount() {
    const devices = await Request.call('getDevices');
    this.setState({ deviceUsed: devices.length });
  }

  render() {
    return (
      <div className="vas-section">
        <div className="vas-card">
          <div className="content">
            <div className="icon">
              <i className="ri-links-line" />
            </div>
            <div className="middle">
              <div className="title">{i18n.t('dash-device-title')}</div>
              <div className="value bind" onClick={() => this.goBind()}>
                <span>
                  {this.state.deviceUsed > store.user.clients
                    ? store.user.clients
                    : this.state.deviceUsed}
                </span>
                <small>/ {store.user.clients}</small>
              </div>
            </div>
            <div className="right">
              {this.state.clientBtn ? (
                <div
                  className="btn-vas"
                  onClick={() =>
                    this.props.history.push(this.state.clientLink)
                  }>
                  {this.state.clientBtn}
                </div>
              ) : (
                ''
              )}

              {store.user.extraClientsExpiredAt &&
                store.user.extraClientsExpiredAt < store.user.planExpiredAt ? (
                <div className="vas-end-date">
                  <span>{i18n.t('dash-device-expire')}:</span>
                  <span>
                    {dayjs(store.user.extraClientsExpiredAt).format(
                      'YYYY.MM.DD',
                    )}
                  </span>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
          <div className="bottom">
            <div
              className="left"
              onClick={() =>
                this.props.history.push(
                  `${!this.state.clientLink
                    ? '/dashboard/vas'
                    : this.state.clientLink
                  }`,
                )
              }>
              {i18n.t('dash-device-plans')} <i className="ri-arrow-right-s-line" />
            </div>
            <div className="btn-bind" onClick={() => this.goBind()}>
              <i className="ri-links-line" />
              {i18n.t('dash-device-title')}
            </div>
          </div>
        </div>
        <div className="vas-card">
          <div className="content">
            <div className="icon">
              <i className="ri-database-line" />
            </div>
            <div className="middle">
              <div className="title">{i18n.t('dash-bw-expire')}</div>
              <div className="value">
                <span>{store.user.bandwidth}</span> <small>Mb</small>{' '}
              </div>
            </div>
            <div className="right">
              {this.state.bandwidthBtn ? (
                <div
                  className="btn-vas"
                  onClick={() =>
                    this.props.history.push(this.state.bandwidthLink)
                  }>
                  {this.state.bandwidthBtn}
                </div>
              ) : (
                ''
              )}

              {store.user.bandwidthExpiredAt &&
                store.user.bandwidthExpiredAt < store.user.planExpiredAt ? (
                <div className="vas-end-date">
                  <span>{i18n.t('dash-bw-expire')}:</span>
                  <span>
                    {dayjs(store.user.bandwidthExpiredAt).format('YYYY.MM.DD')}
                  </span>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
          <div className="bottom">
            <div
              className="left"
              onClick={() =>
                this.props.history.push('/dashboard/vas?planId=bandwidth_100')
              }>
              {i18n.t('dash-bw-plans')} <i className="ri-arrow-right-s-line" />
            </div>
          </div>
        </div>

        <div className="vas-card">
          <div className="content">
            <div className="icon">
              <i className="ri-upload-cloud-line" />
            </div>
            <div className="middle">
              <div className="title">{i18n.t('dash-gbw-title')}</div>
              <div className="value">
                <span>{store.user.gameBandwidth}</span> <small>Mb</small>{' '}
              </div>
            </div>
            <div className="right">
              {this.state.gameBandwidthBtn ? (
                <div
                  className="btn-vas"
                  onClick={() =>
                    this.props.history.push(this.state.gameBandwidthLink)
                  }>
                  {this.state.gameBandwidthBtn}
                </div>
              ) : (
                ''
              )}

              {store.user.gameBandwidthExpiredAt &&
                store.user.gameBandwidthExpiredAt < store.user.planExpiredAt ? (
                <div className="vas-end-date">
                  <span>{i18n.t('dash-gbw-expire')}:</span>
                  <span>
                    {dayjs(store.user.gameBandwidthExpiredAt).format('YYYY.MM.DD')}
                  </span>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
          <div className="bottom">
            <div
              className="left"
              onClick={() =>
                this.props.history.push('/dashboard/vas?planId=game_bandwidth_50')
              }>
              {i18n.t('dash-gbw-plans')} <i className="ri-arrow-right-s-line" />
            </div>
          </div>
        </div>


        <div className="more-rights vas-vip">
          <div className="bind-tips">
            <span>{i18n.t('dash-free-tip')}</span>
            <a className="btn-unbind" href="/dashboard/bind">
              {i18n.t('dash-device-manage')}
            </a>
          </div>
          <div className="title">{i18n.t('dash-turbo-title')}</div>
          <div className="rights-item">
            <div className="items">
              <i className="ri-earth-line" />
              <span>{i18n.t('dash-turbo-tag1')}</span>
            </div>
            <div className="items">
              <i className="ri-hd-line" />
              <span>{i18n.t('dash-turbo-tag2')}</span>
            </div>
            <div className="items">
              <i className="ri-device-line" />
              <span>{i18n.t('dash-turbo-tag3')}</span>
            </div>
            <div className="items">
              <i className="ri-discuss-line" />
              <span>{i18n.t('dash-turbo-tag4')}</span>
            </div>
          </div>
          <a className="vas-btn-vip" href="/buy">
            {i18n.t('dash-turbo-upgrade')}
          </a>
        </div>

        <div className="more-rights vas-svip">
          <div className="title">{i18n.t('dash-game-title')}</div>
          <div className="rights-item">
            <div className="items">
              <i className="ri-gamepad-line" />
              <span>{i18n.t('dash-game-tag1')}</span>
            </div>
            <div className="items">
              <i className="ri-checkbox-multiple-blank-line" />
              <span>{i18n.t('dash-game-tag2')}</span>
            </div>
            <div className="items">
              <i className="ri-device-line" />
              <span>{i18n.t('dash-game-tag3')}</span>
            </div>
            <div className="items">
              <i className="ri-chat-smile-3-line " />
              <span>{i18n.t('dash-game-tag4')}</span>
            </div>
          </div>
          <a className="vas-btn-vip" href="/buy">
          {i18n.t('dash-game-upgrade')}
          </a>
        </div>
      </div>
    );
  }
}

export default VasCards;
